/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable no-restricted-syntax */
/* eslint-disable react/prop-types */
import { memo } from 'react';
// material ui imports core components
import { Grid, Typography } from '@material-ui/core';
// router imports
import { useHistory } from 'react-router-dom';
// import utils
import addSegment from '@shared/utils/Segment';
import HomeLiveStreamCard from 'shared/components/HomeLiveStreamCard/HomeLiveStreamCard';

// styles and assets
import './FeaturedLiveStreamList.css';

function FeaturedLiveStreamList({ liveStreamList }) {
  const numberOfVisibleStreams = 18;
  const history = useHistory();

  const navigateToProfilePage = (username) => {
    addSegment('Popular Channel');
    history.push(`/${username}`);
  };
  const navigateToBrowseLive = () => {
    history.push('/live');
  };
  return (
    <div id='available-livestreams'>
      <Grid
        container
        alignItems='center'
        justifyContent='flex-start'
      >
        <Typography className='livestream-container-title'>LIVESTREAMS</Typography>
        <span onClick={() => navigateToBrowseLive()} className='livestream-view-all link-cursor'>View All</span>
      </Grid>
      <Grid container>
        {
          liveStreamList
            && liveStreamList.slice(0, numberOfVisibleStreams)
              .map((liveStream, _index) => (
                <Grid
                  item
                  key={liveStream.id}
                  className='livestream-card-container'
                  xl={2}
                  lg={2}
                  md={3}
                  sm={4}
                  xs={6}
                >
                  <HomeLiveStreamCard
                    liveStream={liveStream}
                    navigateToProfilePage={navigateToProfilePage}
                  />
                </Grid>
              ))
        }
      </Grid>
    </div>
  );
}

export default memo(FeaturedLiveStreamList);
